import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import Item from './Item'
import Facebook from './Facebook'
import Instagram from './Instagram'

import bemClass from './../../../utils/bemClass'

import './Socials.css'

const cn = bemClass('Socials')

const socialsMap = [
    {
        href: 'https://www.facebook.com/karrotkawaikultura/',
        title: 'Facebook',
        Component: Facebook,
    },
    {
        href: 'https://www.instagram.com/karrotkawaikultura',
        title: 'Instagram',
        Component: Instagram,
    },
]

class Socials extends PureComponent {
    render() {
        const { className } = this.props

        return (
            <div className={`${cn()} ${className}`}>
                {socialsMap.map(social => (
                    <Item
                        key={social.title}
                        {...social}
                    />
                ))}
            </div>
        )
    }
}

Socials.propTypes = {
    className: PropTypes.string,
}

Socials.defaultProps = {
    className: '',
}

export default Socials



// WEBPACK FOOTER //
// ./src/components/Header/Socials/Socials.jsx